import { useEffect } from 'react';
import { Link } from 'react-router-dom';

const sections = [
  {
    title: '1. Acceptation des conditions',
    content: `En accédant au site web de MAX-Sourcing (le « Site ») ou en l'utilisant, vous acceptez d'être lié par ces Conditions d'utilisation et toutes les lois et réglementations applicables. Si vous n'acceptez pas l'une de ces conditions, il vous est interdit d'utiliser ou d'accéder à ce Site. Les documents contenus dans ce Site sont protégés par les lois applicables en matière de droits d'auteur et de marques de commerce.`,
  },
  {
    title: '2. Utilisation du Site',
    content: `Ce Site est fourni à des fins d'information et de demandes commerciales uniquement. Vous pouvez utiliser le Site uniquement à des fins légales et conformément aux présentes Conditions. Vous acceptez de ne pas utiliser le Site d'une manière qui viole les lois ou réglementations locales, nationales ou internationales applicables ; de ne pas transmettre de publicité ou de matériel promotionnel non sollicité ; ou de ne pas adopter une conduite qui restreint ou inhibe l'utilisation ou la jouissance du Site par quiconque.`,
  },
  {
    title: '3. Propriété intellectuelle',
    content: `Tout le contenu de ce Site — y compris, sans s'y limiter, les textes, graphiques, logos, images et logiciels — est la propriété de MAX-Sourcing ou de ses fournisseurs de contenu et est protégé par les lois canadiennes et internationales sur la propriété intellectuelle. Le nom et le logo MAX-Sourcing sont des marques déposées. L'utilisation non autorisée de tout matériel sur ce Site peut violer les lois sur les droits d'auteur, les marques de commerce et d'autres lois.`,
  },
  {
    title: '4. Confidentialité',
    content: `MAX-Sourcing s'engage à maintenir la confidentialité de toutes les informations des clients et des fournisseurs. Toute information soumise via ce Site, y compris via les formulaires de contact ou de candidature fournisseur, sera traitée avec une stricte confidentialité et ne sera pas divulguée à des tiers sans votre consentement préalable, sauf si la loi l'exige. Nous ne vendons, n'échangeons ni ne louons vos informations personnelles à des tiers.`,
  },
  {
    title: '5. Exclusion de garanties',
    content: `Les documents sur ce Site sont fournis « tels quels ». MAX-Sourcing ne donne aucune garantie, expresse ou implicite, et décline par la présente toutes les autres garanties, y compris, sans s'y limiter, les garanties implicites ou les conditions de qualité marchande, d'adéquation à un usage particulier ou de non-violation de la propriété intellectuelle ou d'autres violations de droits.`,
  },
  {
    title: '6. Limitation de responsabilité',
    content: `En aucun cas, MAX-Sourcing ou ses fournisseurs ne seront responsables de tout dommage (y compris, sans s'y limiter, les dommages pour perte de données ou de profit, ou en raison d'une interruption d'activité) découlant de l'utilisation ou de l'impossibilité d'utiliser les documents sur ce Site, même si MAX-Sourcing ou un représentant autorisé a été informé oralement ou par écrit de la possibilité de tels dommages.`,
  },
  {
    title: '7. Liens vers des sites tiers',
    content: `MAX-Sourcing n'a pas examiné tous les sites liés à son Site et n'est pas responsable du contenu de ces sites liés. L'inclusion de tout lien n'implique pas l'approbation par MAX-Sourcing du site. L'utilisation de tout site lié est aux risques et périls de l'utilisateur.`,
  },
  {
    title: '8. Confidentialité & Témoins (Cookies)',
    content: `Lorsque vous visitez notre Site, nous pouvons collecter certaines informations automatiquement, y compris des témoins (cookies) et des technologies de suivi similaires, pour améliorer votre expérience de navigation et analyser le trafic du Site. En continuant à utiliser ce Site, vous consentez à notre utilisation des témoins. Nous utilisons uniquement des témoins essentiels et analytiques — nous n'utilisons pas de témoins publicitaires ou de suivi. Vous pouvez désactiver les témoins via les paramètres de votre navigateur, bien que cela puisse affecter certaines fonctionnalités du Site.`,
  },
  {
    title: '9. Droit applicable',
    content: `Ces Conditions d'utilisation sont régies et interprétées conformément aux lois du Canada, et vous vous soumettez irrévocablement à la juridiction exclusive de ses tribunaux. MAX-Sourcing opère en conformité avec la Loi sur la protection des renseignements personnels et les documents électroniques (LPRPDE) et les législations applicables en matière de protection de la vie privée.`,
  },
  {
    title: '10. Modifications',
    content: `MAX-Sourcing peut réviser ces Conditions d'utilisation à tout moment sans préavis. En utilisant ce Site, vous acceptez d'être lié par la version alors en vigueur de ces Conditions d'utilisation. Nous vous encourageons à consulter cette page périodiquement pour tout changement. Votre utilisation continue du Site après la publication des modifications constitue votre acceptation de ces modifications.`,
  },
  {
    title: '11. Contact',
    content: `Si vous avez des questions sur ces Conditions d'utilisation, veuillez nous contacter via la page Contact de ce Site. Nous nous engageons à répondre à toutes les demandes dans un délai d'un jour ouvrable.`,
  },
];

const TERMS_SCHEMA_FR = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  '@id': `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/fr/conditions#webpage`,
  url: `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/fr/conditions`,
  name: 'Conditions d\'utilisation & Confidentialité | MAX-Sourcing',
  description:
    'Lisez les Conditions d\'utilisation et la Politique de confidentialité du site web de MAX-Sourcing. Régi par la loi du Québec, Canada, en vertu de la LPRPDE.',
  inLanguage: 'fr',
  isPartOf: {
    '@id': `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/#website`,
  },
  dateModified: '2026-04-07',
  about: {
    '@type': 'Organization',
    name: 'MAX-Sourcing',
    url: import.meta.env.VITE_SITE_URL ?? 'https://example.com',
  },
  translationOfWork: {
    '@type': 'WebPage',
    '@id': `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/terms#webpage`,
    url: `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/terms`,
    inLanguage: 'en',
  },
  workTranslation: {
    '@type': 'WebPage',
    '@id': `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/terms#webpage`,
    url: `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/terms`,
    inLanguage: 'en',
  },
};

export default function TermsPageFr() {
  useEffect(() => {
    document.title = 'Conditions d\'utilisation & Confidentialité | MAX-Sourcing';
    window.scrollTo(0, 0);
    const id = 'schema-terms-fr';
    let el = document.getElementById(id) as HTMLScriptElement | null;
    if (!el) {
      el = document.createElement('script');
      el.id = id;
      el.type = 'application/ld+json';
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(TERMS_SCHEMA_FR);
    return () => {
      document.getElementById(id)?.remove();
    };
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-white">
      {/* Hero */}
      <section className="w-full bg-stone-800 pt-36 pb-16 px-6 md:px-16 relative overflow-hidden">
        <div
          className="absolute inset-0 opacity-10"
          style={{ backgroundImage: 'radial-gradient(circle at 30% 50%, #10b981 0%, transparent 60%)' }}
        />
        <div className="max-w-4xl mx-auto relative">
          <span className="text-emerald-400 text-xs font-bold uppercase tracking-widest block mb-4">Légal</span>
          <h1
            className="text-4xl md:text-5xl font-extrabold text-white mb-4"
            style={{ fontFamily: "'DM Serif Display', serif" }}
          >
            Conditions d&apos;utilisation &amp; Confidentialité
          </h1>
          <p className="text-white/60 text-sm leading-relaxed max-w-xl">
            Dernière mise à jour : avril 2026. Veuillez lire attentivement ces conditions avant d&apos;utiliser le site web de MAX-Sourcing.
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="w-full py-16 px-6 md:px-16 flex-1">
        <div className="max-w-4xl mx-auto">

          {/* Intro */}
          <div className="bg-emerald-50 border border-emerald-100 rounded-lg p-6 mb-12">
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 flex items-center justify-center shrink-0">
                <i className="ri-information-line text-emerald-600 text-xl" />
              </div>
              <p className="text-stone-700 text-sm leading-relaxed">
                Ces Conditions d&apos;utilisation régissent votre accès et votre utilisation du site web de MAX-Sourcing. MAX-Sourcing est une entreprise d&apos;approvisionnement de produits alimentaire et de produits chimiques fins dont le siège est au Canada, opérant sous la loi canadienne. Pour toute question, veuillez visiter notre{' '}
                <Link to="/fr/contact" className="text-emerald-700 font-semibold hover:underline cursor-pointer">
                  page Contact
                </Link>.
              </p>
            </div>
          </div>

          {/* Table of contents */}
          <div className="bg-stone-50 border border-stone-100 rounded-lg p-6 mb-12">
            <h2 className="text-xs font-bold uppercase tracking-widest text-stone-500 mb-4">Table des matières</h2>
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2">
              {sections.map((s) => (
                <li key={s.title}>
                  <a
                    href={`#${s.title.replace(/\s+/g, '-').toLowerCase()}`}
                    className="text-sm text-emerald-700 hover:underline cursor-pointer"
                  >
                    {s.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Sections */}
          <div className="space-y-10">
            {sections.map((s) => (
              <div
                key={s.title}
                id={s.title.replace(/\s+/g, '-').toLowerCase()}
                className="border-b border-stone-100 pb-10 last:border-0"
              >
                <h2
                  className="text-xl font-extrabold text-stone-800 mb-4"
                  style={{ fontFamily: "'DM Serif Display', serif" }}
                >
                  {s.title}
                </h2>
                <p className="text-stone-600 text-sm leading-relaxed">{s.content}</p>
              </div>
            ))}
          </div>

          {/* Bottom CTA */}
          <div className="mt-14 bg-stone-50 rounded-lg border border-stone-100 p-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
            <div>
              <p className="text-stone-800 font-bold text-base mb-1">Des questions sur ces conditions ?</p>
              <p className="text-stone-500 text-sm">Notre équipe est heureuse de clarifier quoi que ce soit — contactez-nous directement.</p>
            </div>
            <Link
              to="/fr/contact"
              className="whitespace-nowrap bg-emerald-700 hover:bg-emerald-800 text-white font-bold text-sm px-7 py-3 rounded-md transition-colors cursor-pointer"
            >
              Contactez-nous
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
